import { render, staticRenderFns } from "./OrganizationSettingsPromoters.vue?vue&type=template&id=6f505cea&scoped=true"
import script from "./OrganizationSettingsPromoters.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsPromoters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsPromoters.vue?vue&type=style&index=0&id=6f505cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f505cea",
  null
  
)

export default component.exports